<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate('', true)"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------- Table Content ---------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- ipAddress -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.ipAddress | ipDisplayer"
          ></td-value>
        </td>

        <!-- organizationName -->
        <td>
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- useToLoginPanel -->
        <td>
          <td-value type="boolean" [value]="item?.useToLoginPanel"></td-value>
        </td>
        <!-- useToCreateToken -->
        <td>
          <td-value type="boolean" [value]="item?.useToCreateToken"></td-value>
        </td>

        <!-- status -->
        <td *ngIf="pageId != 'confirm-user-safe-ips'">
          <span [otpStatus]="item?.status" copyToClipboard>{{
            item?.status | enumToText : OtpStatusEnumValues
          }}</span>
        </td>

        <!-- description -->
        <td>
          <td-value [value]="item?.description"></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->

        <!-- table operation  -->
        <td class="sticky-td">
          <div
            app-menu-btn
            [matMenuTriggerFor]="menu"
            [isShowDotsMenu]="true"
          ></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!--*confirm btn -->
            <div
              app-menu-btn
              *ngIf="pageId == 'confirm-user-safe-ips'"
              icon="mdi mdi-check-bold mdi-20px"
              color="green"
              title="pages.safeIps.confirmUserSafeIps"
              (click)="
                onConfirm(item.id, item.useToCreateToken, item.useToLoginPanel)
              "
            ></div>

            <!--*reject btn -->
            <div
              app-menu-btn
              *ngIf="pageId == 'confirm-user-safe-ips'"
              icon="mdi mdi-close-thick mdi-20px"
              color="red"
              title="common.reject"
              (click)="openRejectModal(item.id, item.ipAddress)"
            ></div>

            <!-- *delete btn -->
            <div
              *ngIf="pageId != 'confirm-user-safe-ips'"
              app-menu-btn
              icon="delete"
              (click)="onDelete(item.id, item.ipAddress)"
            ></div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------------------------------- Audit ---------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!----------------------------------------- help -------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageId == 'safe-ips' ? 'SafeIps' : 'ConfirmUserSafeIps'"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
